import moment from 'moment'

const parseTimeIntervals = timeIntervals => {

    let ret = {
        values: [],
        lineNumbers: [],
        status: [],
        linesWithErrors: [],
    }

    let lines = timeIntervals.split('\n')

    lines.map(line => {
        let startAndEndDate = line.split(/[/, \t]/g)
        ret.values.push(startAndEndDate)
    })

    ret.values.forEach((date, lineNumber) => {

        const date1 = moment(date[0], "YYYY-MM-DD", true);
        const date2 = moment(date[1], "YYYY-MM-DD", true);

        if (date1.isValid() && date2.isValid()) {
            if (date1 > date2) {
                ret.status.push('Start date after end date')
            } else {
                const duration = moment.duration(date2.diff(date1))
                const durationAsDays = Math.ceil(duration.add(1, 'day').asDays())
                ret.status.push(
                    'OK, ' + durationAsDays + ' ' +
                    (durationAsDays === 1 ? 'day' : 'days')
                )
            }
        } else {
            ret.status.push('Invalid format')
            ret.linesWithErrors.push(lineNumber + 1)
        }

        ret.lineNumbers.push(lineNumber + 1)

    })

    return ret
}

export default parseTimeIntervals